module.exports = __webpack_public_path__ + "img/coeur_vide.adc3e829.png";